import { MapCheckOutlineIcon } from './MapCheckOutlineIcon';

/**
 * author: mocking-mike
 * id 8EF339C7-1106-40FC-B2CC-3387F915824E
 * name map-check-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-check-outline.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const MapTickOutlineIcon = MapCheckOutlineIcon;
export default MapTickOutlineIcon